import React, { createContext, useContext } from 'react';
import { readAuthSession } from '../services/authService';

const AuthSessionContext = createContext(null);

export function AuthSessionProvider({ session, children }) {
  return (
    <AuthSessionContext.Provider value={session}>
      {children}
    </AuthSessionContext.Provider>
  );
}

/** Prefer live session from ProtectedRoute; fall back to sessionStorage cache. */
export function useAuthSession() {
  const ctx = useContext(AuthSessionContext);
  return ctx || readAuthSession();
}
